import { getById, getAll } from "PARENT/utilities/querySelector.js";


document.addEventListener( 'DOMContentLoaded', function() {
    const anchors = getAll( '[data-check-anchor]' );

    anchors.forEach( anchor => {
        anchor.addEventListener( 'click', handleAnchorClick );
    } );

    /**
     * @param {MouseEvent} e
     *
     * @return {void}
     */
    function handleAnchorClick( e ) {

        const anchor = /** @type {HTMLElement} */ ( e.currentTarget );
        const sectionId = anchor.getAttribute( 'data-check-anchor' ) || '';
        const section = getById( sectionId );

        if ( !section ) return;

        e.preventDefault();
        window.location.hash = sectionId;
        section.scrollIntoView();

    }
}, { once: true } );
